import { Injectable } from '@angular/core';
import { NoteCategoryEnum } from '../../enum/note-category.enum';
import { NoteType } from '../../models/entity/noteType';

@Injectable({
  providedIn: 'root'
})
export class StaticDataService {
  public noteTypes: NoteType[] = [
    { id: 1, name: 'ÜRÜN İADE SEBEBİ', noteCategoryId: NoteCategoryEnum.PRODUCT_REFUND_REASON, screenOrderNo: 0 },
    { id: 2, name: 'SİPARİŞ İPTAL SEBEBİ', noteCategoryId: NoteCategoryEnum.CANCEL_ORDER_REASON, screenOrderNo: 0 },
    { id: 3, name: 'LEKE TİPİ', noteCategoryId: NoteCategoryEnum.PRODUCT_NOTE, screenOrderNo: 0 },
    { id: 4, name: 'MARKA', noteCategoryId: NoteCategoryEnum.PRODUCT_NOTE, screenOrderNo: 0 },
    { id: 5, name: 'ÖZELLİKLER', noteCategoryId: NoteCategoryEnum.PRODUCT_NOTE, screenOrderNo: 0 },
    { id: 6, name: 'RENK', noteCategoryId: NoteCategoryEnum.PRODUCT_NOTE, screenOrderNo: 0 },
    { id: 7, name: 'ÜRÜN HASARLARI', noteCategoryId: NoteCategoryEnum.PRODUCT_NOTE, screenOrderNo: 0 },
    { id: 8, name: 'SİPARİŞ NOTLARI', noteCategoryId: NoteCategoryEnum.ORDER_NOTE, screenOrderNo: 0 },
    { id: 9, name: 'SERVİS İPTAL SEBEBİ', noteCategoryId: NoteCategoryEnum.CANCEL_SERVICE_REASON, screenOrderNo: 0 },
    { id: 10, name: 'SİPARİŞ ETİKETLERİ', noteCategoryId: NoteCategoryEnum.ORDER_TAG, screenOrderNo: 0 },
    { id: 11, name: 'KARGO NOTLARI', noteCategoryId: NoteCategoryEnum.SHIPMENT_NOTE, screenOrderNo: 0 },

  ];
  constructor() { }
}
